import {
    faCalculator,
    faCalendar,
    faMoneyBillWave,
    faMoneyCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColumnDescription } from "react-bootstrap-table-next";
import StickyToolbar from "../../../Components/StickyToolbar";
import { IGestaoBoleto } from "../../../Interfaces/Cobranca/Boleto/BoletoInterface";
import SpinnerComponent from "../../../Components/Loding/Spinner";
import { formatMoneyReais } from "../../../Tools/FormatTools";
import Swal from "sweetalert2";
import {
    AtualizarBoletoNaoQuitadoCasoCobrancaNegociacaoParcelasParcelasController,
    AtualizarBoletoQuitadoCasoCobrancaNegociacaoParcelasController,
} from "../../../Controllers/Cobranca/CasoCobrancaNegociacaoParcelas/CasoCobrancaNegociacaoParcelasController";
import { ExportarExcelBoletosGestaoController } from "../../../Controllers/Cobranca/Boleto/BoletoController";
import ExportExcel from "../../../Components/StickyToolbar/ExportExcel";
import LeiaMais from "../../../Components/Utils/LeiaMais";
import FiltroGestaoAcordos from "./FiltroGestaoAcordos";
import { useGestaoAcordosCobranca } from "./useGestaoAcordosCobranca";
import Table from "../../../Components/Table";

function GestãoAcordosCobranca() {
    const {
        loading,
        UserInfor,
        totalPages,
        filter,
        totalNegociado,
        indicadores,
        LstBoletos,
        updateList,
        FILTRO_GESTAO_ACORDOS_COBRANCA,
        handleDateChange,
        register,
        control,
        handleSubmit,
        reset,
        lstUnidades,
        lstUsuarios,
        setFilter,
        lstEmpreendimentos,
        filtroInicial,
        handleEmpreendimento,
    } = useGestaoAcordosCobranca();
    function RowTable(cell: any, row: IGestaoBoleto) {
        return (
            <RowTable
                row={row}
                updateList={updateList}
                filter={filter}
                UserInfor={UserInfor}
            />
        );
    }
    const columnsTableView: Array<ColumnDescription<IGestaoBoleto>> = [
        {
            dataField: "ID_CASO",
            text: "Protocolo",
        },
        {
            dataField: "DS_NOME",
            text: "Cliente",
        },
        {
            dataField: "USUARIO_SOLICITANTE",
            text: "Solicitante",
        },
        {
            dataField: "DS_PRODUTO_COMP",
            text: "Produto",
            formatter: (_, row) =>
                `${row.DS_PRODUTO_COMP.split("-")[0]} - ${
                    row.DS_PRODUTO_COMP.split("-")[2 || 1]
                }`,
        },
        {
            dataField: "EMPRESA",
            formatter: (_, row) => `${row.EMPRESA}_${row.OBRA}_${row.VENDA}`,
            text: "Chave ERP",
        },
        {
            dataField: "NR_PARCELA",
            formatter: (_, row) =>
                `${row.DS_TIPO_PARCELA ? row.DS_TIPO_PARCELA : row.DS_TIPO}-${
                    row.NR_PARCELA
                }`,
            text: "Parcela",
        },
        {
            dataField: "NR_PARCELA_GERAL",
            text: "Parcela Geral",
        },
        {
            dataField: "DS_OBSERVACAO",
            text: "Descrição",
            formatter: (c) => (
                <LeiaMais customLeiaMais="+" customLeiaMenos="-" charLimit={20}>
                    {c}
                </LeiaMais>
            ),
            classes: "p-2 min-w-100px",
        },
        {
            dataField: "DS_ULTIMO_HISTORICO",
            text: "Histórico",
            formatter: (c) => (
                <LeiaMais customLeiaMais="+" customLeiaMenos="-" charLimit={20}>
                    {c}
                </LeiaMais>
            ),
            classes: "p-2",
        },
        {
            dataField: "DS_CLASSIFICACAO_CONTRATO",
            text: "Classificação",
        },
        {
            dataField: "DT_SOLICITACAO",
            text: "Solicitação",
            formatter: (c) => (c ? new Date(c).toLocaleDateString() : ""),
        },
        {
            dataField: "DT_RECEBIMENTO_UAU",
            text: "Recebimento ERP",
            formatter: (c) => (c ? new Date(c).toLocaleDateString() : ""),
        },
        {
            dataField: "DT_VENCIMENTO",
            text: "Vencimento",
            formatter: (c) => (c ? new Date(c).toLocaleDateString() : ""),
        },
        {
            dataField: "VL_PARCELA",
            text: "Valor",
            formatter: (c) => formatMoneyReais(c),
        },
        {
            dataField: "VL_RECEBIMENTO_UAU",
            text: "Valor Recebimento ERP",
            formatter: (c) => formatMoneyReais(c),
        },
        {
            dataField: "FL_RECEBIDO",
            formatter: (recebido) => (recebido ? "Recebido" : "Pendente"),
            text: "Recebimento",
        },
        {
            dataField: "DS_TIPO_RECEBIMENTO",
            text: "Tipo de Recebimento",
        },
        {
            dataField: "DS_STATUS_PARCELA",
            text: "Boleto",
        },
    ];
    if (UserInfor.FUNCOES.some((f) => f.NM_FUNCAO === "ADM_BOLETO_QUITADO")) {
        columnsTableView.push({
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (_, row) =>
                row.DS_STATUS_PARCELA !== "Quitado" ? (
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm text-uppercase font-weight-bolder mt-5 mt-sm-0 mr-2"
                        onClick={() => {
                            Swal.fire({
                                title: "Tem certeza que deseja marcar como boleto quitado?",
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    AtualizarBoletoQuitadoCasoCobrancaNegociacaoParcelasController(
                                        row.ID_CASO_COBRANCA_NEGOCIACAO_PARCELAS
                                    ).then(() => {
                                        updateList({
                                            ...filter,
                                            NR_PAGINA: 1,
                                        });
                                    });
                                }
                            });
                        }}
                    >
                        Boleto Quitado
                    </button>
                ) : (
                    ""
                ),
        });
    }
    if (
        UserInfor.FUNCOES.some(
            (f) => f.NM_FUNCAO === "ADM_BOLETO_NAO_QUITADO_TODOS"
        )
    ) {
        columnsTableView.push({
            dataField: "",
            text: "",

            isDummyField: true,
            formatter: (_, row) =>
                row.DS_STATUS_PARCELA !== "Não Quitado" ? (
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm text-uppercase font-weight-bolder mt-5 mt-sm-0 mr-2"
                        onClick={() => {
                            Swal.fire({
                                title: "Tem certeza que deseja marcar como boleto não quitado?",
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    AtualizarBoletoNaoQuitadoCasoCobrancaNegociacaoParcelasParcelasController(
                                        row.ID_CASO_COBRANCA_NEGOCIACAO_PARCELAS
                                    ).then(() => {
                                        updateList({
                                            ...filter,
                                            NR_PAGINA: 1,
                                        });
                                    });
                                }
                            });
                        }}
                    >
                        Boleto Não Quitado
                    </button>
                ) : (
                    ""
                ),
        });
    }

    const ColunsObras: Array<ColumnDescription> = [
        {
            dataField: "ID_CASO_COBRANCA_NEGOCIACAO_PARCELAS",
            text: "Acordos",
            formatter: RowTable,
            sort: true,
            isDummyField: true,
        },
    ];

    return LstBoletos ? (
        <div className="table-responsive-sm">
            {!loading && (
                <div className="card card-custom p-2 d-flex align-items-center flex-wrap flex-md-row flex-column">
                    <div className="d-flex align-items-center justify-content-center flex-fill mr-2 my-1">
                        <span className="mr-4">
                            <FontAwesomeIcon
                                icon={faMoneyCheck}
                                className="icon-2x text-muted font-weight-bold"
                            />
                        </span>
                        <div className="d-flex flex-column text-dark-75">
                            <span className="font-weight-bolder font-size-sm">
                                Boletos Quitados
                            </span>
                            <span className="font-weight-bolder font-size-h6">
                                <span className="text-dark-50 font-weight-bold"></span>
                                {indicadores.QTD_ACORDOS_QUITADOS ?? 0} -{" "}
                                {formatMoneyReais(
                                    indicadores.VL_ACORDOS_QUITADOS ?? 0
                                )}
                            </span>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center flex-fill mr-2 my-1">
                        <span className="mr-4">
                            <FontAwesomeIcon
                                icon={faMoneyBillWave}
                                className="icon-2x text-muted font-weight-bold"
                            />
                        </span>
                        <div className="d-flex flex-column text-dark-75">
                            <span className="font-weight-bolder font-size-sm">
                                Boletos Não Quitados
                            </span>
                            <span className="font-weight-bolder font-size-h5">
                                {indicadores.QTD_ACORDOS_N_QUITADOS ?? 0} -{" "}
                                {formatMoneyReais(
                                    indicadores.VL_ACORDOS_N_QUITADOS ?? 0
                                )}
                            </span>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center flex-fill mr-2 my-1">
                        <span className="mr-4">
                            <FontAwesomeIcon
                                icon={faCalendar}
                                className="icon-2x text-muted font-weight-bold"
                            />
                        </span>
                        <div className="d-flex flex-column text-dark-75">
                            <span className="font-weight-bolder font-size-sm">
                                Promessas em aberto
                            </span>
                            <span className="font-weight-bolder font-size-h5">
                                {indicadores.QTD_N_ENVIADOS ?? 0} -{" "}
                                {formatMoneyReais(
                                    indicadores.VL_N_ENVIADOS ?? 0
                                )}
                            </span>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center flex-fill mr-2 my-1">
                        <span className="mr-4">
                            <FontAwesomeIcon
                                icon={faCalculator}
                                className="icon-2x text-muted font-weight-bold"
                            />
                        </span>
                        <div className="d-flex flex-column text-dark-75">
                            <span className="font-weight-bolder font-size-sm">
                                Total Negociado
                            </span>
                            <span className="font-weight-bolder font-size-h5">
                                {totalNegociado.QTD_TOTAL_NEGOCIADO ?? 0} -{" "}
                                {formatMoneyReais(
                                    totalNegociado.VL_TOTAL_NEGOCIADO ?? 0
                                )}
                            </span>
                        </div>
                    </div>
                </div>
            )}

            <Table
                keyField="ID_CASO_COBRANCA_NEGOCIACAO_PARCELAS"
                data={LstBoletos}
                columns={ColunsObras}
                noDataIndication={"Nenhum boleto encontrado"}
                noHover
                noSearch
                bordered={false}
                loading={loading}
                remote={{ pagination: true }}
                totalPages={totalPages}
                onTableChange={(type, newState) => {
                    updateList({ NR_PAGINA: newState.page, ...filter });
                }}
                tableView={{
                    columns: columnsTableView,
                    cancelYScroll: true,
                    defaultStyle: true,
                    defaultClasses: "p-1",
                    noSort: true,
                }}
            />
            <StickyToolbar
                Filters={
                    <FiltroGestaoAcordos
                        handleDateChange={handleDateChange}
                        register={register}
                        control={control}
                        handleSubmit={handleSubmit}
                        reset={reset}
                        lstUnidades={lstUnidades}
                        lstUsuarios={lstUsuarios}
                        filter={filter}
                        setFilter={setFilter}
                        lstEmpreendimentos={lstEmpreendimentos}
                        filtroInicial={filtroInicial}
                        handleEmpreendimento={handleEmpreendimento}
                    />
                }
                active={!!FILTRO_GESTAO_ACORDOS_COBRANCA}
            />
            <ExportExcel
                baixarExcelController={() =>
                    ExportarExcelBoletosGestaoController({
                        ...filter,
                        NR_PAGINA: 0,
                    })
                }
                nomeArquivo={`BoletosGerados_${new Date().toDateString}`}
            />
        </div>
    ) : (
        <SpinnerComponent />
    );
}

export default GestãoAcordosCobranca;
